import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobDetails from "./pages/JobDetails";
import Companies from "./pages/Companies";
import PostJob from "./pages/PostJob";
import Dashboard from "./pages/Dashboard";
import CareerTips from "./pages/CareerTips";
import ResumeTips from "./pages/ResumeTips";
import MockInterviews from "./pages/MockInterviews";
import InterviewMistakes from "./pages/InterviewMistakes";
import UpskillingCourses from "./pages/UpskillingCourses";
import HighPayingSkills from "./pages/HighPayingSkills";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import FAQs from "./pages/FAQs";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Terms from "./pages/Terms";
import Chatbot from "./pages/Chatbot";
import Resume from "./pages/Resume";
import ATSScore from "./pages/ATSScore";

const App = () => {
  const [visitorCount, setVisitorCount] = useState(180);

  useEffect(() => {
    fetch("https://job-spot-pi.vercel.app") // Use your deployed backend URL
      .then((res) => res.json())
      .then((data) => setVisitorCount(data.count))
      .catch((err) => console.error("Error fetching visitor count:", err));
  }, []);
  

  return (
    <Router>
      <Navbar />
      <div style={{ textAlign: "center", marginTop: "10px", fontSize: "18px", fontWeight: "bold" }}>
        Total Visitors: {visitorCount}
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:id" element={<JobDetails />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/postjob" element={<PostJob />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/careertips" element={<CareerTips />} />
        <Route path="/resumetips" element={<ResumeTips />} />
        <Route path="/mockinterviews" element={<MockInterviews />} />
        <Route path="/interviewmistakes" element={<InterviewMistakes />} />
        <Route path="/upskillingcourses" element={<UpskillingCourses />} />
        <Route path="/highpayingskills" element={<HighPayingSkills />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/chatbot" element={<Chatbot />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/atsscore" element={<ATSScore />} />
      </Routes>
      <Footer />
      <Chatbot />
    </Router>
  );
};

export default App;

